module.exports = __webpack_public_path__ + "static/Conversation-e3aaae78a3bbb403c69917e220c26abc.png";